<template>
    
    <div class=" main-content mt-3 mx-3">
        <div class="grid">
            <div class="sm:col-12 md:col-9 lg:col-9 mt-2">
                <div >
                    <label class=" ml-2 text-xl font-medium">Department Orders</label>
                </div>
            </div>
            <div class="lg:col-3 md:col-3 sm:col-12 mt-2">
                <div class="flex justify-content-between flex-wrap">
                    <div class="flex align-items-center justify-content-center">
                        <label class=" ml-2 text-xl font-medium">Orders Analytics</label>
                    </div>
                    <div class="flex align-items-center justify-content-center">
                        <router-link to="/add-dept-po"  rel="noopener">
                            <Button label="New PO" icon="pi pi-plus" raised ></Button>
                        </router-link>
                    </div>
                </div>
            </div>
            
        </div>

        <div class="grid">
            <div class="lg:col-9 md:col-9 sm:col-12">
                <div class="flex">
                    <div class="flex-initial flex justify-content-center w-full">
                        <OrdersComponent />
                    </div>
                </div>
            </div>
            <div class="lg:col-3 md:col-3 sm:col-12">
                <div class="flex">
                    <div class="flex-initial flex justify-content-center w-full">
                        <AnalyticsComponent />
                    </div>
                </div>
            </div>               
        </div>            
    </div>

</template>

<script>
import Button from 'primevue/button';
import AnalyticsComponent from './analyticsComponent.vue';
import OrdersComponent from './ordersComponent.vue';


export default {
    components:{
        AnalyticsComponent,
        OrdersComponent,
        Button,
    },
    data(){
        return{
            // ordersKey:0,
            // analyticsKey:0,
        }
    },
}
</script>

<style>

</style>